<template>
  <modal :title="title" @close="$emit('close')"
    :open="true">
    <p v-html="content"></p>

    <div class="modal__done">
      <button class="button" @click="$emit('resolve')">
        <span>{{ buttonText }}</span>
      </button>
      <a v-t class="button--close" @click="$emit('close')">Cancel</a>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue'

export default {
  components: {
    Modal,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
}
</script>
